import { ChainId } from 'mojitoswap-sdk'
import tokens from 'constants/tokens'

export default {
  [ChainId.MAINNET]: {
    name: 'MojitoSwap Default Mainnet List',
    timestamp: '2021-08-14 02:26:00',
    version: {
      major: 2,
      minor: 9,
      patch: 0,
    },
    tags: {},
    logoURI: '',
    keywords: ['mojito', 'default'],
    tokens: [
      {
        name: 'Wrapped KCS',
        symbol: 'WKCS',
        address: tokens.wkcs.address[ChainId.MAINNET],
        chainId: ChainId.MAINNET,
        decimals: 18,
      },
      {
        name: 'MojitoSwap Token',
        symbol: 'MJT',
        address: tokens.mjt.address[ChainId.MAINNET],
        chainId: ChainId.MAINNET,
        decimals: 18,
      },
      {
        name: 'KCC-Peg Wrapped BTC',
        symbol: 'BTCK',
        address: tokens.btck.address[ChainId.MAINNET],
        chainId: ChainId.MAINNET,
        decimals: 18,
      },
      {
        name: 'KCC-Peg Wrapped ETH',
        symbol: 'ETH',
        address: tokens.eth.address[ChainId.MAINNET],
        chainId: ChainId.MAINNET,
        decimals: 18,
      },
      {
        name: 'KCC-Peg Tether USD',
        symbol: 'USDT',
        address: tokens.usdt.address[ChainId.MAINNET],
        chainId: ChainId.MAINNET,
        decimals: 18,
      },
      {
        name: ' KCC-Peg USD Coin',
        symbol: 'USDC',
        address: tokens.usdc.address[ChainId.MAINNET],
        chainId: ChainId.MAINNET,
        decimals: 18,
      },
    ],
  },

  [ChainId.TESTNET]: {
    name: 'MojitoSwap Default Testnet List',
    timestamp: '2021-08-14 02:26:00',
    version: {
      major: 2,
      minor: 9,
      patch: 0,
    },
    tags: {},
    logoURI: '',
    keywords: ['mojito', 'default'],
    tokens: [
      {
        name: 'Wrapped KCS',
        symbol: 'WKCS',
        address: tokens.wkcs.address[ChainId.TESTNET],
        chainId: ChainId.TESTNET,
        decimals: 18,
      },
      {
        name: 'MojitoSwap Token',
        symbol: 'MJT',
        address: tokens.mjt.address[ChainId.TESTNET],
        chainId: ChainId.TESTNET,
        decimals: 18,
      },
      {
        name: 'KCC-Peg Wrapped BTC',
        symbol: 'BTCK',
        address: tokens.btck.address[ChainId.TESTNET],
        chainId: 322,
        decimals: 18,
      },
      {
        name: 'KCC-Peg Wrapped ETH',
        symbol: 'ETH',
        address: '0xF8Cb9f1D136Ff4c883320b5B4fa80048b888F459',
        chainId: 322,
        decimals: 18,
      },
      {
        name: 'KCC-Peg Tether USD',
        symbol: 'USDT',
        address: tokens.usdt.address[ChainId.TESTNET],
        chainId: ChainId.TESTNET,
        decimals: 18,
      },
      {
        name: ' KCC-Peg USD Coin',
        symbol: 'USDC',
        address: tokens.usdc.address[ChainId.TESTNET],
        chainId: ChainId.TESTNET,
        decimals: 18,
      }
    ],
  },
}
